import $ from '../core/Dom';

export default el => {

    const $el = $(el);
    const start = new Date().getTime();

    const poll = time => {
        if (window.$zissonWebChat) {
            if (window.$zissonWebChat.isOpen) {
                $el.text($el.data('text-open'));
                $el.addClass('-online');
            } else {
                $el.text($el.data('text-closed'));
                $el.removeClass('-online');
            }
            $el.on('click', () => {
                window.$zissonWebChat.openWidget();
            });
        } else if ((time - start) < 8000) {
            window.requestAnimationFrame(poll);
        }
    };

    const init = () => {
        window.requestAnimationFrame(poll);
    };

    return {
        init
    };

};
